import { render, staticRenderFns } from "./preClassification.vue?vue&type=template&id=737da596&scoped=true&"
import script from "./preClassification.vue?vue&type=script&lang=js&"
export * from "./preClassification.vue?vue&type=script&lang=js&"
import style0 from "./preClassification.vue?vue&type=style&index=0&id=737da596&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737da596",
  null
  
)

export default component.exports